import { Text, VStack } from '@enechain/ecloud-designsystem'

type Props = {
  messages: string[]
}

/**
 * Step2 の差分プレビューのエラー内容列に出す、 1 行ぶんの文言の並び。
 * 1 行に複数の違反があれば並び順のまま全部出す。
 */
export const CsvRowErrorMessages = ({
  messages,
}: Props): React.ReactElement => (
  <VStack align="stretch" gap={0}>
    {messages.map((message, index) => (
      <Text key={`${index}:${message}`}>{message}</Text>
    ))}
  </VStack>
)
